import baseAPI from '@/http'

const router = 'api/projeto'

export const projectAPI = {
  create: (project) => baseAPI.post(router, project),
  update: (project) => baseAPI.put(router, project),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  getProjetoByUf: (uf) => baseAPI.get(`${router}/get-projeto-by-uf?uf=${uf}`)
}
